import { definePlugin } from 'villus';

import { useRoute } from 'vue-router';

/**
 * Sets the craft token header for all requests if defined in the URL
 */
const craftPreview = () => {
    const { query } = useRoute();

    return definePlugin(({ opContext }) => {
        // This is the actual header which Craft needs
        if (Object.hasOwnProperty.call(query, 'x-craft-live-preview') && query?.token) {
            opContext.headers['X-Craft-Token'] = query?.token?.toString();
        }
    });
};
export default craftPreview;
